import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import PricingSection from './PricingSection';
import AIAssistantSection from './AIAssistantSection';
import CTASection from './CTASection';
import LandingFooter from './LandingFooter';

interface LandingPageProps {
  onGetStarted: () => void;
}

export default function LandingPage({ onGetStarted }: LandingPageProps) {
  return (
    <>
      <HeroSection onGetStarted={onGetStarted} />
      <FeaturesSection />
      <PricingSection onGetStarted={onGetStarted} />
      <AIAssistantSection />
      <CTASection onGetStarted={onGetStarted} />
      <LandingFooter />
    </>
  );
}
